/* eslint-disable react/prop-types */
/* eslint-disable max-len */

import React from 'react'
import styled from 'styled-components'
import { QuestionCircleOutlined } from '@ant-design/icons'

const TooltipContent = styled.div`

  display: none;
  position: absolute;
  z-index: 2;
  top: -60px;
  left: 10px;
`

const ToolTipStyled = styled.div`
  position: relative;

  .tooltip-icon:hover + ${TooltipContent} {
    display: block;
  }
`

const ToolTip = ({ children }) => (
  <>
    <ToolTipStyled>
      <QuestionCircleOutlined className="tooltip-icon" />
      <TooltipContent className="tooltip-content">
        {
          children
        }
      </TooltipContent>
    </ToolTipStyled>

  </>
)

export default ToolTip
